import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ServicePermissions } from "@screens/login/LoginVerification";

export interface PermissionState {
  userPermissions: ServicePermissions;
}

const initialState: PermissionState = {
  userPermissions: {},
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermissions(
      state,
      action: PayloadAction<{ permissions: ServicePermissions }>
    ) {
      state.userPermissions = action.payload.permissions;
    },
  },
});

export const { setPermissions } = permissionSlice.actions;

export default permissionSlice.reducer;
